import { hotSites } from "@/mocks/manhwaData";

interface HotSitesProps {
  onNotify: (msg: string) => void;
}

const rankColors = [
  "bg-primary-500",
  "bg-accent-500",
  "bg-secondary-500",
];

export default function HotSites({ onNotify }: HotSitesProps) {
  const handleEnter = (name: string) => {
    try {
      navigator.clipboard?.writeText(name);
    } catch {
      /* ignore */
    }
    onNotify(`已复制「${name}」入口，前往对应站点即可阅读`);
  };

  return (
    <section id="hot" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-fire-line"></i>
              人气推荐
            </span>
            <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">热门韩漫站点推荐</h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              根据近期访问热度与更新频率整理的精选韩漫网址入口，点开即可直达阅读页。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {hotSites.map((site) => (
            <article
              key={site.id}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-200"
            >
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-3">
                  <span
                    className={`flex h-10 w-10 items-center justify-center rounded-lg font-heading text-lg text-background-50 ${
                      rankColors[(site.rank - 1) % 3]
                    }`}
                  >
                    {site.rank}
                  </span>
                  <div>
                    <h3 className="flex items-center gap-2 text-base font-bold text-foreground-950">
                      {site.name}
                      {site.hot && (
                        <span className="rounded-full bg-accent-500 px-2 py-0.5 text-[10px] font-medium text-foreground-950">
                          本周热门
                        </span>
                      )}
                    </h3>
                    <p className="text-xs text-foreground-500">{site.tagline}</p>
                  </div>
                </div>
                <span className="flex items-center gap-1 text-xs font-medium text-accent-600">
                  <i className="ri-star-fill"></i>
                  {site.rating.toFixed(1)}
                </span>
              </div>

              <p className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">{site.desc}</p>

              <div className="mt-4 flex flex-wrap gap-1.5">
                {site.tags.map((tag) => (
                  <span
                    key={tag}
                    className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-800"
                  >
                    {tag}
                  </span>
                ))}
              </div>

              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-4">
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {site.viewers}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {site.update}
                  </span>
                </div>
                <button
                  type="button"
                  onClick={() => handleEnter(site.name)}
                  className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-3 py-1.5 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  直达入口
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}